import { EntityBusiness } from '@efex-components/common/Form/config';
import { IPagination, PayableTypes } from '@efex-services/client/types';
import { Country, Currency } from '@configs/language';

export enum ActionHistory {
  CREATE_PAYMENT = 'CREATE_PAYMENT',
  APPROVE_PAYMENT = 'APPROVE_PAYMENT',
}

export type CurrencyIds = 1 | 2 | 3;

interface IPaymentStatus {
  id: number;
  name: PayableTypes;
  is_active: boolean;
}

interface NaturalPerson {
  uuid: string;
  firstName: string;
  lastName: string;
  nickname: string | null;
  email: string;
  phone_number: string | null;
  country: Country;
  contactId?: string | number;
}

interface Enterprise {
  id: number;
  name: string;
  rfc: string;
  irs: string;
  website: string;
  country: Country;
  account_currency: Currency | null;
  entity_type: EntityBusiness;
}

export interface IEnterpriseContact {
  naturalPerson: NaturalPerson;
  enterprise: Enterprise;
  bankAccount?: BankAccount;
}

export interface IRate {
  uuid: string;
  bid: string;
  ask: string;
  value: string;
}

export interface IEnterprisePayment {
  action_history?: IActionHistory[];
  amount: number;
  comment: string;
  paymentReason: string;
  contact: IEnterpriseContact;
  contactId: number;
  currencyId: CurrencyIds;
  desAmount: number | string;
  desCurrencyId: CurrencyIds;
  dueDate: string;
  fee: number;
  hasFee: boolean;
  id: number;
  invoiceNumber: number;
  isWalletDeposit: boolean;
  name: string;
  paymentMethodId: number;
  paymentOriginId: number;
  rate?: IRate;
  status: IPaymentStatus;
  transactionTypeId: number;
  uuid: string;
  viewStatus: string;
  partialPayments?: PartialPayment[];
  executionDate?: string;
  forwardRemainingInfo?: ForwardRemainingInfo;
  enterpriseAccount: IEnterpriseAccount;
}

interface ForwardRemainingInfo {
  remainingAmount: number;
  remainingDesAmount: number;
  remainingPercentage: number;
  currency: Currency;
  desCurrency: Currency;
}

interface IEnterpriseAccount {
  swiftCode: string;
  accountNumber: string;
  clabe: string;
}

export interface BankAccount {
  id?: number;
  bank_name?: string;
  bank_address?: any;
  clabe?: string;
  routing_number?: string;
  account_number?: string;
  account_type?: string;
  currency?: any;
  swift_code?: any;
}

export type IEnterprisePayments = IPagination<IEnterprisePayment>;

export interface PartialPayment {
  id: number;
  amount: number;
  percentage: string;
  createdAt: string;
  convertedAmount: number;
}

export type IGetPayments = {
  enterpriseId: number;
  search?: string;
  page?: number;
  dateFrom?: string;
  dateTo?: string;
  status?: string;
};

export type IApprovePayment = {
  payment_id: string;
  is_approve: boolean;
};

export type IActionHistory = {
  action: ActionHistory;
  created_at: string;
  user_first_name: string;
  user_last_name: string;
};
